import { Button, LinearProgress } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import Icon from 'icons/Icons'
import { useEffect, useState } from 'react'

const CustomBackdrop = ({
  type,
  content,
  closable = false,
  autoclose,
  open = false,
  onHide = () => {},
}) => {
  const [openBackdrop, setOpenBackdrop] = useState(open)
  const [progress, setProgress] = useState(100)

  useEffect(() => {
    setOpenBackdrop(open)
    let timer
    let interval
    if (open && autoclose) {
      timer = setTimeout(() => {
        setProgress(100)
        setOpenBackdrop(false)
        clearInterval(interval)
        onHide()
      }, autoclose)
      interval = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress === 0) {
            setOpenBackdrop(false)
            clearInterval(interval)
            onHide()
            return 100
          }
          const diff = 100 / (autoclose / 250)
          return Math.max(oldProgress - diff, 0)
        })
      }, 250)
    }
    return () => {
      clearTimeout(timer)
      clearInterval(interval)
    }
  }, [open, autoclose, onHide])

  const handleClose = () => {
    setOpenBackdrop(false)
    onHide()
  }

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
      }}
      open={openBackdrop}
    >
      {type === 'success' ? (
        <Icon icon="fi-rr-check-circle" color="success.main" size="48px" />
      ) : type === 'error' ? (
        <Icon icon="fi-rr-cross-circle" color="error.main" size="48px" />
      ) : null}
      {content}
      {autoclose ? (
        <LinearProgress variant="determinate" value={progress} sx={{ width: '80%' }} />
      ) : null}
      {closable ? (
        <Button variant="cotained" color="primary" size="small" onClick={handleClose}>
          Cerrar
        </Button>
      ) : null}
    </Backdrop>
  )
}

export default CustomBackdrop
